import { forwardRef, ReactNode } from 'react'
import { CustomContentProps } from 'notistack'
import MuiAlert, { AlertColor } from '@mui/material/Alert'

import { useStyles } from './styles'

interface IProps extends CustomContentProps {}

export const NotificationBar = forwardRef<HTMLDivElement, IProps>((props, ref) => {
  const classes = useStyles()

  return (
    <MuiAlert
      ref={ref}
      elevation={6}
      variant="filled"
      severity={props.variant as AlertColor}
      action={props.action as ReactNode}
      className={classes.alert}
    >
      <>{props.message}</>
    </MuiAlert>
  )
})
